






















































































































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import SEODetail from '@/modules/seo/components/SEODetail.vue'
import {notify, Colors} from '@/modules/core/notification'
import {Action, State, Getter, Mutation} from 'vuex-class'
import {Product} from '@/modules/product'
import LoadingScreen from '@/modules/core/LoadingScreen'
import Editor from '@/components/Editor.vue'
import ProductTranslation from '@/modules/product/model/ProductTranslation'
import ProductTranslationSelector from '@/modules/product/components/ProductTranslationSelector.vue'
import ProductImage from '@/modules/product/components/ProductImage.vue'
import ProductSaveConfirm from '@/modules/product/components/ProductSaveConfirm.vue'
import {MutationTypes} from '@/modules/product/store/mutations'
import {mutationName} from '@/store/mutations'
import {SEOCompletor} from '@/modules/seo/types'
import {buildProductSEOCompletor} from '@/modules/product/util/ProductSEOCompletor.ts'
import StyleMixin from '@/modules/core/style/StyleMixin'
import I18nMixin from '@/modules/i18n/mixins/I18nMixin'
import TranslationSelect from '@/modules/i18n/components/TranslationSelect.vue';

/**
 * Componente detalle del producto
 *
 * Muestra la información de un producto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'seo-detail': SEODetail,
        'editor': Editor,
        'translation-selector': ProductTranslationSelector,
        'product-image': ProductImage,
        'save-confirm': ProductSaveConfirm,
        TranslationSelect,
    },
})
export default class ProductDetail extends mixins(StyleMixin, I18nMixin) {

    public $refs: {
        seoDetail: SEODetail,
    }

    @State(state => state.product.currentProduct)
    public product: Product

    @Mutation('product/product/image/show')
    public showProductImage: (show: boolean) => void

    @Mutation('product/product/save/confirm/show')
    public showSaveConfirm: (show: boolean) => void

    @Mutation(mutationName(MutationTypes.UpdateProductTranslationField, 'product'))
    public updateTranslationField: (payload: { path: string, value: any }) => void

    @Mutation(mutationName(MutationTypes.UpdateProductField, 'product'))
    public updateProductField: (payload: { path: string, value: any }) => void

    @Getter('product/currentTranslation')
    public translation: ProductTranslation

    @Action('product/loadProduct')
    public loadProduct: (id: string) => void

    public floating = false

    get visible () {
        return this.product.visible
    }

    set visible (value: boolean) {
        this.updateProductField({path: 'visible', value})
    }

    public completor = buildProductSEOCompletor()
    public loading = true

    /**
     * Actualiza un campo de la traducción actualmente en edición
     */
    public updateTranslation (path: string, value: any) {
        this.updateTranslationField({path, value})

        this.$refs.seoDetail.complete()
    }

    public async created () {
        LoadingScreen.show('Cargando producto')
        const id = this.$router.currentRoute.params.id || ''
        if (!id) {
            this.$router.push({name: 'dashboard'})
            notify('No se ha proporcionado ningún id', Colors.Warning)
        }

        await this.loadProduct(id)

        LoadingScreen.hide()
        this.loading = false
    }
}
